import React, { ReactNode, useRef } from 'react';

import styled, { StyledProp } from '@/styled';

export interface IProps {
  children?: ReactNode[];
  onReachedEnd: () => void;
}

const InfiniteScroll = (props: IProps & StyledProp) => {
  const listRef = useRef<HTMLDivElement>();
  const onScroll = () => {
    const divElement = listRef.current;
    const scrollCurrentIndex = divElement.offsetHeight + divElement.scrollTop;
    const thresholdIndex = divElement.scrollHeight;

    if (scrollCurrentIndex >= thresholdIndex) {
      props.onReachedEnd();
    }
  };

  return (
    <div ref={listRef} onScroll={onScroll} className={props.className}>
      {props.children}
    </div>
  );
};

export default styled(InfiniteScroll)`
  overflow-x: hidden;
  overflow-y: scroll;
`;
